import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import PostCard from "../components/PostCard";

const dummyPosts = [
  {
    id: 1,
    username: "@RajeshBihar",
    location: "Patna, Bihar",
    content: "3 days se bijli nahi hai! @MLABhagat #Electricity #Patna",
    time: "2h ago",
    image: "",
    likes: 12,
    comments: [],
  },
  {
    id: 2,
    username: "@PriyaYouth",
    location: "Darbhanga, Bihar",
    content: "Why no action on the road near college? #RoadIssue @MLAKumar",
    time: "5h ago",
    image: "",
    likes: 20,
    comments: [],
  },
];

const JanSabhaFeed = () => {
  const [posts, setPosts] = useState([]);
  const [content, setContent] = useState("");
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    setPosts(dummyPosts);
  }, []);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    const url = URL.createObjectURL(selectedFile);
    setPreviewUrl(url);
  };

  const handlePost = () => {
    if (!content.trim()) return;

    const newPost = {
      id: Date.now(),
      username: "@You",
      location: "Your Area",
      content,
      time: "just now",
      image: previewUrl,
      likes: 0,
      comments: [],
    };

    setPosts((prev) => [newPost, ...prev]);

    setContent("");
    setPreviewUrl(null);
  };

  const isVideo =
    previewUrl &&
    previewUrl.toLowerCase().match(/\.(mp4|webm|ogg)$/);

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-100 via-white to-green-100 py-10 px-4">
      <div className="max-w-4xl mx-auto">

        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-4xl font-bold text-center text-orange-700 mb-6 drop-shadow"
        >
          🗣️ जन सभा - Bharat Discussion Feed
        </motion.h1>

        {/* Post Box */}
        <div className="bg-white border border-orange-300 rounded-xl shadow-md p-4 mb-6">

          <textarea
            rows={3}
            placeholder="What's your issue or opinion? Use @MLAname or #hashtag"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            className="w-full border border-gray-300 rounded p-3 focus:outline-none focus:ring-2 focus:ring-green-500"
          />

          {previewUrl && (
            <div className="mt-3 w-full max-h-64 rounded overflow-hidden border">

              {isVideo ? (
                <video
                  src={previewUrl}
                  controls
                  muted
                  className="w-full h-auto max-h-64 rounded border"
                />
              ) : (
                <img
                  src={previewUrl}
                  alt="preview"
                  className="w-full object-contain"
                />
              )}

            </div>
          )}

          <div className="flex justify-between items-center mt-2">

            <input
              type="file"
              accept="image/*,video/*"
              onChange={handleFileChange}
              className="text-sm"
            />

            <button
              onClick={handlePost}
              className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded shadow"
            >
              ✍️ Post
            </button>

          </div>

        </div>

        {/* Feed */}
        <div className="space-y-4 max-h-[70vh] overflow-y-auto pr-2">

          {posts.map((post) => (
            <PostCard
              key={post.id}
              post={post}
              onLike={(id) => console.log("Like:", id)}
              onComment={(id) => console.log("Comment:", id)}
            />
          ))}

        </div>

      </div>
    </div>
  );
};

export default JanSabhaFeed;